<template>
  <div class="content-container">
    <!-- Early Checkin Table -->
    <!-- <h3>Nhận phòng sớm</h3>
    <div class="grid-scroll">
      <GridVx
        ref="agGrid"
        :columns="columns"
        :rows="rowsEarlyData"
        class="agGrid"
        @refresh="onRefresh"
        @doubleClicked="onDoubleClicked"
      />
    </div> -->
    <!-- Late Checkout Table  -->
    <!-- <h3>Trả phòng muộn</h3>
    <div class="grid-scroll">
      <GridVx
        ref="agGrid"
        :columns="columns"
        :rows="rowsLateData"
        class="agGrid"
        @refresh="onRefresh"
        @doubleClicked="onDoubleClicked"
      />
    </div> -->
    <div v-loading="loading" class="grid-scroll">
      <!-- :suppress-row-click-selection="true" -->
      <GridVx
        ref="agGrid"
        :auto-select-first-row="false"
        :columns="columns"
        :rows="rows"
        :is-row-selectable="isRowSelectable"
        :auto-size-cell="true"
        row-selection="single"
        class="agGrid"
        @refresh="onRefresh"
        @selectionChanged="onSelectRow"
      />
    </div>
    <div class="button-containers mb-0">
      <button class="btn primary small outline" @click="deleteConfiguration">
        <!-- :disabled="!selectedRow" -->
        {{ $t('button.deleteConfiguration') }}
      </button>
      <button class="btn primary small" @click="fnOpenEditDialog">
        <!-- :disabled="!selectedRow" -->
        {{ $t('button.modifyConfiguration') }}
      </button>
      <button class="btn primary small" @click="fnOpenAddDialog">
        {{ $t('button.addConfiguration') }}
      </button>

      <!-- <button class="btn primary small outline">Sửa thuế</button> -->
    </div>
    <el-dialog
      :title="
        isEditDialog
          ? $t('dialog.titleConfigurationModify')
          : $t('dialog.titleConfigurationAdd')
      "
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="720px"
    >
      <!-- START FORM -->
      <div class="das-form-container">
        <validation-observer ref="formValidator">
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label required">{{ $t('field.type') }}</div>
                  <validation-provider
                    rules="required"
                    :name="$t('field.type')"
                  >
                    <div class="child-w-80">
                      <!-- <select v-model="formConfigData.type">
                        <option :key="0" label="Nhận phòng sớm" :value="0" />
                        <option :key="1" label="Trả phòng muộn" :value="1" />
                      </select> -->
                      <el-select
                        v-model="formConfigData.type"
                        placeholder=""
                        class="el-select__disable-custom"
                        :disabled="isEditDialog"
                      >
                        <el-option
                          v-for="item in earlyAndLateTypeOptions"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        />
                      </el-select>
                    </div>
                  </validation-provider>
                </div>
              </div>
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label required">{{ $t('field.timeFrame') }}</div>
                  <div class="input-container">
                    <!-- <SingleCalendar mode="time" /> -->
                    <!-- <SingleCalendar mode="time" /> -->
                    <validation-provider
                      :name="$t('field.timeFrameStart')"
                      rules="required"
                    >
                      <el-time-picker
                        v-model.lazy="formConfigData.time_frame_from"
                        format="HH:mm"
                        value-format="HH:mm"
                        style="width: 100%"
                        @change="onChangeTime($event, 'time_frame_from')"
                      />
                    </validation-provider>
                    <validation-provider
                      :name="$t('field.timeFrameEnd')"
                      rules="required"
                    >
                      <el-time-picker
                        v-model.lazy="formConfigData.time_frame_to"
                        format="HH:mm"
                        value-format="HH:mm"
                        style="width: 100%"
                        @change="onChangeTime($event, 'time_frame_to')"
                      />
                    </validation-provider>
                  </div>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label required">{{ $t('field.code') }}</div>
                  <validation-provider
                    :name="$t('field.code')"
                    rules="required|max:20|no_special"
                  >
                    <div class="child-w-80">
                      <input
                        v-model="formConfigData.code"
                        :readonly="isEditDialog"
                        type="text"
                      />
                    </div>
                  </validation-provider>
                </div>
              </div>
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label required">
                    {{ $t('field.chargesAmount') }}
                  </div>
                  <div class="input-container">
                    <div style="width: 50%">
                      <validation-provider
                        :name="$t('field.chargesAmount')"
                        rules="required"
                      >
                        <el-select
                          v-model="formConfigData.fee_type"
                          placeholder=""
                          @change="formConfigData.fee_val = null"
                        >
                          <el-option
                            v-for="item in feeTypeOptions"
                            :key="item.value"
                            :value="item.value"
                            :label="item.label"
                          />
                        </el-select>
                      </validation-provider>
                    </div>
                    <div style="width: 50%">
                      <validation-provider
                        v-if="formConfigData.fee_type === 0"
                        :name="$t('field.chargesAmountValuePercent')"
                        rules="required|min_value:0|number|max_value:100"
                      >
                        <input
                          v-model.number="formConfigData.fee_val"
                          v-numeric-only
                          min="0"
                          type="text"
                        />
                      </validation-provider>
                      <validation-provider
                        v-else
                        :name="$t('field.chargesAmountValueMoney')"
                        rules="required|min_value:0|number|max:100"
                      >
                        <VxCurrencyInput v-model="formConfigData.fee_val" />
                      </validation-provider>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label required">
                    {{ $t('field.transactionCode') }}
                  </div>
                  <validation-provider
                    :name="$t('field.transactionCode')"
                    rules="required"
                  >
                    <div class="child-w-80">
                      <select-with-search-table
                        style="width: 100%"
                        index-field="id"
                        :rows="transactionOptions"
                        :columns="transactionOptionsCols"
                        :value="formConfigData?.transaction_id"
                        :search-fields="['code', 'description']"
                        :selected-index-field-value="
                          formConfigData?.transaction_id
                        "
                        @selectionChanged="onChangeTransaction"
                      >
                        <template
                          v-slot:value="{ selectedValue: selectedData }"
                        >
                          <span v-if="selectedData?.code">
                            {{ selectedData?.description }}
                          </span>
                        </template>
                      </select-with-search-table>
                    </div>
                  </validation-provider>
                </div>
              </div>
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label required">
                    {{ $t('field.subTransactionCode') }}
                  </div>
                  <validation-provider
                    :name="$t('field.subTransactionCode')"
                    rules="required"
                  >
                    <div class="child-w-80">
                      <select-with-search-table
                        style="width: 100%"
                        index-field="id"
                        :rows="subTransactionOptions"
                        :columns="subTransactionOptionsCols"
                        :value="formConfigData?.sub_transaction_id"
                        :search-fields="['code', 'description']"
                        :selected-index-field-value="
                          formConfigData?.sub_transaction_id
                        "
                        @selectionChanged="onChangeSubTransaction"
                      >
                        <template
                          v-slot:value="{ selectedValue: selectedData }"
                        >
                          <span v-if="selectedData?.code">
                            {{ selectedData?.description }}
                          </span>
                        </template>
                      </select-with-search-table>
                    </div>
                  </validation-provider>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label required">
                    {{ $t('field.currencyUnit') }}
                  </div>
                  <validation-provider
                    :name="$t('field.currencyUnit')"
                    rules="required"
                  >
                    <div class="child-w-80">
                      <select-with-search-table
                        style="width: 100%"
                        index-field="id"
                        :search-fields="['code', 'currency_unit']"
                        :selected-index-field-value="
                          formConfigData?.currency_id
                        "
                        :rows="currencyOptions"
                        :columns="currOptionsCols"
                        :value="formConfigData?.currency_id"
                        @selectionChanged="onSelectCurrency"
                      >
                        <template
                          v-slot:value="{ selectedValue: selectedData }"
                        >
                          <span v-if="selectedData?.code">{{
                            selectedData?.code
                          }}</span>
                        </template>
                      </select-with-search-table>
                    </div>
                  </validation-provider>
                </div>
              </div>
              <!-- <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label">
                    {{ $t('field.equivalentRoomNight') }} (%)
                  </div>
                  <validation-provider
                    rules="min_value:0|number|max_value:100"
                    :name="$t('field.equivalentRoomNight')"
                  >
                    <div class="child-w-80 flex align-center">
                      <input
                        v-model.number="formConfigData.equivalent_room_night"
                        v-numeric-only
                        type="number"
                        min="0"
                      />
                    </div>
                  </validation-provider>
                </div>
              </div> -->
            </div>
          </div>
        </validation-observer>
      </div>
      <!-- END FORM -->

      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="dialogFormVisible = false"
          >
            {{ $t('button.cancel') }}
          </button>
          <button
            v-if="isEditDialog"
            class="btn primary small"
            @click="updateConfiguration"
          >
            {{ $t('button.update') }}
          </button>
          <button v-else class="btn primary small" @click="addConfiguration">
            {{ $t('button.create') }}
          </button>
        </div>
        <!-- <el-button @click="dialogFormVisible = false">Huỷ</el-button>
        <el-button
          v-if="isEditDialog"
          type="primary"
          @click="updateConfiguration"
        >Cập nhật</el-button>
        <el-button
          v-else
          type="primary"
          @click="addConfiguration"
        >Tạo mới</el-button> -->
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import bus from '@/utils/bus'
const DEFAULT_FORM_CONFIG_DATA = {
  id: null,
  type: null,
  code: null,
  transaction_id: null,
  sub_transaction_id: null,
  time_frame_from: '',
  time_frame_to: null,
  fee_type: null,
  fee_val: null,
  currency_id: null,
  equivalent_room_night: null
}

const getDefaultFormConfigData = () => ({
  id: null,
  type: null,
  code: null,
  transaction_id: null,
  sub_transaction_id: null,
  time_frame_from: '',
  time_frame_to: null,
  fee_type: null,
  fee_val: null,
  currency_id: null,
  equivalent_room_night: null
})

import {
  getEarlyLateCheckConfigApi,
  addEarlyLateCheckConfigApi,
  updateEarlyLateCheckConfigApi,
  deleteEarlyLateCheckConfigApi
} from '@/api/Service_Policy/earlyLateCheckManage'
import {
  getTransactionListApi,
  getSubTransactionListApi
} from '@/api/common/transaction'
import { getAllCurrencyApi } from '@/api/common/currency'
import { Message } from 'element-ui'
import SingleCalendar from '@/components/ui/SingleCalendar.vue'

export default {
  components: {
    SingleCalendar
  },
  data() {
    return {
      loading: false,
      selectOptions: [
        {
          name: 'default',
          id: '01'
        }
      ],
      formConfigData: {
        id: null,
        type: null,
        code: null,
        transaction_id: null,
        sub_transaction_id: null,
        time_frame_from: '',
        time_frame_to: null,
        fee_type: null,
        fee_val: null,
        currency_id: null
      },
      totalPage: 0,
      currentPage: 0,
      isEditDialog: false,
      dialogFormVisible: false,
      searchParams: {
        // page_size: 10,
        // page_num: 1,
        // orderTp: 'ASC'
      },
      transactionOptions: [],
      subTransactionOptions: [],
      currencyOptions: [],
      feeTypeOptions: [
        {
          value: 0,
          label: this.$t('variables.percentage')
        },
        {
          value: 1,
          label: this.$t('variables.amountOfMoney')
        }
      ],
      earlyAndLateTypeOptions: [
        {
          value: 0,
          label: this.$t('variables.checkInEarly')
        },
        {
          value: 1,
          label: this.$t('variables.checkOutLate')
        }
      ],

      rowsEarlyData: [],
      rowsLateData: [],
      rows: [],
      isRowSelectable: node => !node.data.isFullWidthRow,
      selectedRow: null

      // SELECT TABLE COLUMNS
    }
  },
  watch: {
    dialogFormVisible() {
      this.dialogFormVisible
        ? null
        : setTimeout(() => {
            this.resetDialog()
          }, 500)
    }
  },
  computed: {
    columns() {
      return [
        {
          headerName: this.$t('grid.column.code'),
          field: 'code',
          tooltipField: 'code',
          // cellClass: "grid-cell-centered",
          minWidth: 150,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.timeFrame'),
          // cellClass: "grid-cell-centered",
          minWidth: 150,
          sortable: false,
          valueGetter: params => {
            return (
              params.data.time_frame_from + ' - ' + params.data.time_frame_to
            )
          }
        },
        {
          headerName: this.$t('grid.column.percentage'),
          field: 'fee_val',
          cellRenderer: params => {
            if (params.data.fee_type == 0 && params.value) {
              return params.value
            } else {
              return null
            }
          },
          // cellClass: "grid-cell-centered",
          minWidth: 100,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.amountOfMoney'),
          field: 'fee_val',
          cellRenderer: params => {
            if (
              params.data.fee_type == 1 &&
              params.value !== null &&
              params.value !== undefined
            ) {
              return Number(params.value).toLocaleString('en')
            } else {
              return null
            }
          },
          // cellClass: "grid-cell-centered",
          minWidth: 200,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.transactionCode'),
          field: 'transaction_desc',
          // cellClass: "grid-cell-centered",
          minWidth: 130,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.subTransactionCode'),
          field: 'sub_transaction_desc',
          // cellClass: "grid-cell-centered",
          minWidth: 150,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.currencyUnit'),
          field: 'currency_code',
          // cellClass: "grid-cell-centered",
          minWidth: 130,
          sortable: false
        }
        // {
        //   headerName: this.$t('grid.column.equivalentRoomNight') + ' (%)',
        //   field: 'equivalent_room_night',
        //   // cellClass: "grid-cell-centered",
        //   minWidth: 250,
        //   sortable: false
        // }
      ]
    },

    // SELECT TABLE COLUMNS
    transactionOptionsCols() {
      return [
        {
          headerName: this.$t('grid.column.code'),
          field: 'code',
          tooltipField: 'code',

          // cellClass: "grid-cell-centered",
          flex: 1,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.desc'),
          field: 'description',
          tooltipField: 'description',
          // cellClass: "grid-cell-centered",
          flex: 3,
          sortable: false
        }
      ]
    },

    subTransactionOptionsCols() {
      return [
        {
          headerName: this.$t('grid.column.code'),
          field: 'code',
          tooltipField: 'code',
          // cellClass: "grid-cell-centered",
          flex: 1,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.desc'),
          field: 'description',
          tooltipField: 'description',
          // cellClass: "grid-cell-centered",
          flex: 3,
          sortable: false
        }
      ]
    },

    currOptionsCols() {
      return [
        {
          headerName: this.$t('grid.column.code'),
          field: 'code',
          // cellClass: "grid-cell-centered",
          flex: 1,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.desc'),
          field: 'currency_unit',
          tooltipField: 'currency_unit',
          // cellClass: "grid-cell-centered",
          flex: 3,
          sortable: false
        }
      ]
    }
  },

  mounted() {
    this.attachData()

    // GET SELECT OPTIONS
    this.fnGetTransactionOptions()
    this.fnGetCurrencyOptions()

    this.gridApi = this.$refs.agGrid.gridApi
  },
  methods: {
    onRefresh(data) {
      let params = {
        orderBy: data.orderBy,
        orderTp: data.sort
      }
      this.searchParams = { ...this.searchParams, ...params }
      this.attachData()
    },
    // async onPageChanged(pageNum) {
    //   this.searchParams.page_num = pageNum;
    //   await this.attachData();
    // },
    // async onPageSizeChange(pageSize) {
    //   this.searchParams.page_size = pageSize;
    //   this.searchParams.page_num = 1;
    //   await this.attachData();
    // },
    async attachData() {
      // bus.$emit('startLoader', { msg: '' })
      this.loading = true
      try {
        let resData = await getEarlyLateCheckConfigApi(this.searchParams)
        // bus.$emit('endLoader')
        this.loading = false
        const rowsEarlyData = resData?.data?.early
        const rowsLateData = resData?.data?.late
        if (rowsEarlyData) {
          this.rows = [
            {
              name: this.$t('grid.column.earlyCheckIn'),
              isFullWidthRow: true
            },
            ...rowsEarlyData
          ]
        }
        if (rowsLateData) {
          this.rows = [
            ...this.rows,
            {
              name: this.$t('grid.column.lateCheckIn'),
              isFullWidthRow: true
            },
            ...rowsLateData
          ]
        }
      } catch (err) {}

      this.loading = false
      // this.totalPage = Math.ceil(resData.total / this.searchParams.page_size);
      // this.currentPage = data.data.length == 0 ? 0 : this.searchParams.page_num;
      // this.currentPage = data.data.length == 0 ? 0 : data.page_num;
    },

    /**
     * @return {Boolean}
     */
    // fnValidate() {
    //   if (!this.formConfigData.type || !this.formConfigData.code) {
    //     this.$alert('Bạn phải điền đủ các trường thông tin', 'Error', {
    //       confirmButtonText: 'OK'
    //     })
    //     return false
    //   }
    //   return true
    // },
    async addConfiguration() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) == false)
        return

      await addEarlyLateCheckConfigApi(this.formConfigData)
        .then(res => {
          this.$message({
            type: 'success',
            message: this.$t('successMsg.' + res.message)
          })
          this.attachData()
          this.dialogFormVisible = false
        })
        .catch(err => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.' + err.response.data.message)
          })
        })
    },
    async updateConfiguration() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) == false)
        return

      updateEarlyLateCheckConfigApi(this.formConfigData.id, this.formConfigData)
        .then(res => {
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t('successMsg.' + res.message)
          })
          this.attachData()
        })
        .catch(err => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.' + err.response.data.message)
          })
        })
    },

    async deleteConfiguration() {
      const rowsSelected = this.gridApi.getSelectedRows()

      if (!rowsSelected?.length) {
        this.$message({
          message: this.$t('errorMsg.selectConfiguration'),
          type: 'error'
        })
      } else {
        let id_list = rowsSelected.map(item => item.id)
        this.$vxConfirm(this.$t('alert.deleteConfiguration'), {
          resolveText: 'OK',
          rejectText: 'Cancel',
          resolve: () => {
            deleteEarlyLateCheckConfigApi(id_list)
              .then(res => {
                this.$message({
                  type: 'success',
                  message: this.$t('successMsg.' + res.message)
                })
                this.attachData()
              })
              .catch(err => {
                this.$message({
                  type: 'error',
                  message: this.$t('errorMsg.' + err.response.data.message)
                })
              })
          }
        })
      }
    },

    async fnOpenAddDialog() {
      this.dialogFormVisible = true
    },
    onSelectRow(rows) {
      // if(!rows?.length) {
      //   this.isEditDialog = false
      // } else {
      //   this.isEditDialog = true;
      // }

      this.selectedRow = rows[0]
    },

    fnOpenEditDialog() {
      const rowsSelected = this.gridApi.getSelectedRows()

      if (!rowsSelected?.length) {
        this.$message({
          message: this.$t('errorMsg.selectConfiguration'),
          type: 'error'
        })
      } else if (rowsSelected.length !== 1) {
        this.$message({
          message: this.$t('errorMsg.selectOneConfigurationOnly'),
          type: 'error'
        })
      } else {
        this.isEditDialog = true
        this.formConfigData = {
          id: this.selectedRow.id,
          type: this.selectedRow.type,
          code: this.selectedRow.code,
          transaction_id: this.selectedRow.transaction_id,
          sub_transaction_id: this.selectedRow.sub_transaction_id,
          time_frame_from: this.selectedRow.time_frame_from,
          time_frame_to: this.selectedRow.time_frame_to,
          fee_type: this.selectedRow.fee_type,
          fee_val: this.selectedRow.fee_val,
          currency_id: this.selectedRow.currency_id,
          equivalent_room_night: this.selectedRow.equivalent_room_night
        }
        this.fnGetSubTransOptions(this.selectedRow.transaction_id)
        this.dialogFormVisible = true
      }
    },
    resetDialog() {
      this.formConfigData = getDefaultFormConfigData()
      this.subTransactionOptions = []
      this.isEditDialog = false
    },

    // GET SELECT OPTIONS
    async fnGetCurrencyOptions() {
      const data = await getAllCurrencyApi()
      this.currencyOptions = data.data
    },

    async fnGetTransactionOptions() {
      const resData = await getTransactionListApi()
      this.transactionOptions =
        resData.data.filter(item => item.transaction_group === 1) || []
    },
    onChangeTransaction(data) {
      // this.formConfigData.transaction_code = '1';
      this.formConfigData.transaction_id = data?.id
      this.formConfigData.sub_transaction_id = null
      this.fnGetSubTransOptions(data?.id)
    },
    async fnGetSubTransOptions(transactionId) {
      if (transactionId) {
        const resData = await getSubTransactionListApi(transactionId)
        this.subTransactionOptions = [...resData.data]
      }
    },
    onChangeSubTransaction(data) {
      this.formConfigData.sub_transaction_id = data?.id
    },
    onSelectCurrency(data) {
      this.formConfigData.currency_id = data?.id
    },
    onChangeTime(value, field) {
      switch (field) {
        case 'time_frame_from':
          if (
            this.formConfigData.time_frame_to &&
            value >= this.formConfigData.time_frame_to
          ) {
            this.formConfigData.time_frame_to = null
          }
          this.formConfigData.time_frame_from = value
          break
        case 'time_frame_to':
          if (
            this.formConfigData.time_frame_from &&
            value <= this.formConfigData.time_frame_from
          ) {
            this.$message({
              message: this.$t('errorMsg.timeFrameStartMustBeforeEnd'),
              type: 'error'
            })
            this.formConfigData.time_frame_to = null
          } else {
            this.formConfigData.time_frame_to = value
          }
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

// .el-form-item {
//   margin-bottom: 10px;
// }
</style>

<style lang="scss">
@import '~@/styles/variables.scss';

.el-select__disable-custom {
  .el-input.is-disabled .el-input__inner {
    background-color: $input-bg-color !important;
    color: $text-default-color;
  }
}
</style>
